import { isInside } from './formTree';
export const getFieldsInBlock = (form, block) => {
  if (!form || !block) return;
  return form.fields.filter((field) => isInside(block.box, field.box));
};
export const getBlocksInBlock = (form, block) => {
  if (!form || !block) return;
  return form.blocks.filter((_block) => isInside(block.box, _block.box) && block.id !== _block.id);
};
